import Services from './base-services'

const service = new Services('survey')

export default {
    findSurveyByUser(userId: any) {
        return service.get(`findSurveyByUser?userId=${userId}`)
    },
    uploadSurveyAnswers(data: any) {
        return service.post(`uploadSurveyAnswers`, data)
    },
}
